// src/components/CtaBoostSection.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faRocket } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

import './CtaBoostSection.css';

export default function CtaBoostSection() {
  const perks = [
    'Beter vindbaar in Google',
    'Professionele, converterende website',
    'Groei op social media',
    'Meetbare resultaten & dashboards',
    'Slimme SEA-campagnes',
    'Full-service support',
  ];

  return (
    // extra py-md-6 voor ruimere desktop-spacing
    <section className="cta-section py-5 py-md-6">
      <div className="container">
        <div className="cta-box shadow-sm">
          {/* Titel */}
          <h2 className="cta-heading text-center mb-4">
            Boost jouw online groei
          </h2>

          <div className="row gx-lg-5 gy-4 align-items-center">
            {/* Links: tekst en bullets */}
            <div className="col-12 col-lg-7">
              <h3 className="cta-subheading mb-3">
                Klaar om vooruit te gaan?
              </h3>
              <p className="cta-intro mb-4">
                Ontdek hoe <strong>OnlineGrowthClub.nl</strong>{' '}
                <span className="highlight">online zichtbaarheid</span> verbetert
                en bezoekers omzet in klanten.
              </p>

              <ul className="perk-list list-unstyled">
                {perks.map((p, i) => (
                  <li key={i} className="perk-item">
                    <FontAwesomeIcon icon={faCheckCircle} className="perk-icon" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>

            {/* Rechts: CTA-kaart */}
            <div className="col-12 col-lg-5">
              <div className="cta-card text-center">
                <div className="rocket-wrapper mb-3">
                  <FontAwesomeIcon icon={faRocket} size="lg" />
                </div>
                <h4 className="card-title mb-3">Begin vandaag nog</h4>

                <Link to="/contact" className="btn btn-orange btn-lg w-100 mb-3">
                  Ontvang gratis groeiscan
                </Link>
                <Link to="/diensten" className="btn btn-outline-orange btn-lg w-100">
                  Bekijk onze cases
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
